import React from 'react';

import { Form, Row, Col, Input, Select, Button, DatePicker, } from 'antd';

import {
    SearchOutlined,
    ReloadOutlined,
} from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;

class MemberSearchForm extends React.Component {

    render() {
        const dateFormat = 'YYYY/MM/DD';
        const onFinishFailed = (errorInfo: any) => {
            console.log('Failed:', errorInfo);
        };
        const onReload = () => {
            window.location.reload();
        };
        return (
            <div>
                <Form
                    layout='inline'
                >
                    <Row gutter={[18, 24]}>
                        <Col>
                            <Form.Item
                                name="user"
                            >
                                <Input allowClear placeholder="请输入用户名/昵称/手机号" defaultValue="" />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item
                                name="from"
                                label="来源"
                            >
                                <Select defaultValue="">
                                    <Option value="">全部</Option>
                                    <Option value="1">自营</Option>
                                    <Option value="2">飞猪</Option>
                                    <Option value="3">携程</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col>
                            <Form.Item
                                name="from"
                                label="等级"
                            >
                                <Select defaultValue="0">
                                    <Option value="0">全部</Option>
                                    <Option value="1">M1</Option>
                                    <Option value="2">M2</Option>
                                    <Option value="3">M3</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col>
                            <Form.Item
                                name="from"
                                label="是否有订单"
                            >
                                <Select defaultValue="0">
                                    <Option value="0">全部</Option>
                                    <Option value="1">是</Option>
                                    <Option value="2">否</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col>
                            <Form.Item
                                name="registerTime"
                                label="注册时间"
                            >
                                <RangePicker
                                    format={dateFormat}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[24, 12]}>
                        <Col>
                            <Button type="primary" htmlType="submit">
                                <SearchOutlined />
									搜索
								</Button>
                        </Col>
                        <Col>
                            <Button
                                type="default"
                                onClick={onReload}
                            >
                                <ReloadOutlined />
									重置
								</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}

export default MemberSearchForm;